import { Component, ViewChild, HostListener } from '@angular/core';
import { WellDetailsModel } from '../_models/well-details-model';
import { UserWellsService } from '../user-wells.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableFilter } from 'mat-table-filter';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { ExportManagerService } from '../_services/export-manager.service';
import { ExcelImportService } from '../_services/excel-import.service';
import { InjectionService } from '../_services/injection.service';
import { UserAccountService } from '../_services/user-account.service'
import { BHPService } from '../_services/bhp.service';
import { ExportOption } from '../_models/export-option';
import { ExportRequest } from '../_models/export-request';
import { FormationsForWellRequestModel } from '../_models/formations-for-well-request-model';
import { FormationsForWellResponseModel } from '../_models/formations-for-well-response-model';
import { ExportDateRangeSelectorComponent } from '../export-date-range-selector/export-date-range-selector.component';
import { SelectPeriodDialogComponent } from '../select-period-dialog/select-period-dialog.component'
import { BhpDialogComponent } from '../bhp-dialog/bhp-dialog.component'
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { ImportExcelDataComponent } from '../import-excel-data/import-excel-data.component';
import { LoadingDialogComponent } from '../loading-dialog/loading-dialog.component';
import { ApiResultErrorDialogComponent } from '../api-result-error-dialog/api-result-error-dialog.component';
import { WellsListFilterModel } from '../_models/wells-list-filter-model';
import { UserPrefsModel } from '../_models/user-prefs-model'
import { UserPrefsExchangeModel } from '../_models/user-prefs-exchange-model'
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  public displayedColumns: string[] = ['selection', 'details', 'Apinumber', 'Uicnumber', 'LeaseName', 'WellNumber', 'OperatorOperatorName', 'InjectionTopInterval', 'InjectionBottomInterval', 'LastInjectionDate', 'InjectionsCount', 'favorite'];
  public wellData: Array<WellDetailsModel>;

  selection = new SelectionModel<WellDetailsModel>(true, []);

  dataSource: MatTableDataSource<WellDetailsModel>;

  filterEntity: WellsListFilterModel;

  controllerName: string;


  filterParams: any = {};

  filterType: MatTableFilter;

  excelTemplateDataSubscription: Subscription;
  submitInjectionBatchSubscription: Subscription;
  submitBhpBatchSubscription: Subscription;

  loadingDialog: MatDialogRef<LoadingDialogComponent>;
  messageDialog = null;

  userPrefs: UserPrefsModel = {
    FavoriteWellIds: []
  };
  saveUserPrefsTimeout;

  @ViewChild(MatSort) matSort: MatSort;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    public userWellsService: UserWellsService,
    public exportManagerService: ExportManagerService,
    protected excelImportService: ExcelImportService,
    public injectionService: InjectionService,
    public bhpService: BHPService,
    public userAcountService: UserAccountService,
  ) {

    var initData = new Array<WellDetailsModel>();

    this.excelTemplateDataSubscription = this.excelImportService.currentExcelTemplateData.subscribe((x: any) => {

      if (x != null) {
        //Turn formation names into ids

        //Get unique Well Ids
        let wellIds = x.Injections.reduce((acc, val) => {
          if (val.WellId && !acc.includes(val.WellId)) {
            acc.push(val.WellId);
          }
          return acc;
        }, []);
        let reqModel: FormationsForWellRequestModel = {
          wellIds
        }

        let loadingConfig: any = {};
        loadingConfig.data = {
          title: 'Submission in Progress',
          body: 'Loading... Large submissions may take some time, please wait.'
        };

        if (this.controllerName == 'injection') {
          //Get Formations Name to Id lookup table
          this.userWellsService.getFormationsForWellIds(reqModel).then((formations: FormationsForWellResponseModel) => {
            let invalidFormationList = [];
            //Replace Names with Ids
            let multiWellBatch = x.Injections.map((injection) => {
              let formationNames = injection.FormationIds.split(',');
              injection.FormationIds = formationNames.map((name) => {
                //Get specific array that corrilates to wellId
                let formationMapList = formations.formationsByWellId[injection.WellId];
                if (formationMapList) {
                  //Find the matching formation name from list and return
                  let formationName = formationMapList.reduce((acc, val) => {
                    if (val.Name == name) {
                      acc = val.Id;
                    }
                    return acc;
                  }, null);
                  if (!formationName) {
                    let formationNameWithWell = name + ' (' + injection.WellId + ')';
                    if (invalidFormationList.indexOf(formationNameWithWell) == -1) {
                      invalidFormationList.push(formationNameWithWell);
                    }
                  }
                  return formationName;
                }
              });
              return injection;
            });

            if (x.Injections.length > 0) {
              //If no invalid formations are found submit multiwellbatch
              if (invalidFormationList.length == 0) {
                this.injectionService.SubmitMultiWellBatch(x, this.controllerName);
                this.loadingDialog = this.dialog.open(LoadingDialogComponent, loadingConfig);
              } else {
                this.dialog.open(MessageDialogComponent, {
                  data: {
                    title: "Invalid Formations Names",
                    message: `The following formation(s): ${invalidFormationList.join(', ')} are not found in the Well's formation list. Please provide the correct formation(s) for each record and try again.`
                  }
                });
              }
            }
            else {
              this.dialog.open(MessageDialogComponent, {
                data: {
                  title: "No valid records",
                  message: "The provided injection data does not contain any valid records, and cannot be submitted.  Please ensure that you have filled out the the template without altering it."
                }
              });
            }
          });
        }

        if (this.controllerName == 'injectionPressure') {

          if (x.Injections.length > 0) {
            this.loadingDialog = this.dialog.open(LoadingDialogComponent, loadingConfig);
            this.bhpService.SubmitMultiWellBatch(x, this.controllerName);
          }
          else {
            this.dialog.open(MessageDialogComponent, {
              data: {
                title: "No valid records",
                message: "The provided injection pressure data does not contain any valid records, and cannot be submitted.  Please ensure that you have filled out the the template without altering it."
              }
            });
          }
        }
      }
    });

    //Subscribe to the result parameter on the injection service.
    this.submitInjectionBatchSubscription = this.injectionService.submitBatchResult.subscribe((x) => {

      //Close loading dialog
      if (this.loadingDialog) {
        this.loadingDialog.close();
      }

      if (x != null) {

        //If error is return with reasons load the error dialog component
        if (x.Reasons && x.Reasons.length > 0) {
          this.dialog.open(ApiResultErrorDialogComponent, {
            data: x
          });
        } else {
          let title, message;
          if (x.Success == true) {
            title = 'Success';
            message = 'Your injection records have been submitted successfully.';
          }
          else {
            title = 'Error';
            message = 'Something went wrong with your submission, please review your template and try again.';
          }
          if (!this.messageDialog) {
            this.messageDialog = this.dialog.open(MessageDialogComponent, {
              data: {
                title: title,
                message: message
              }
            }).afterClosed().subscribe(() => {
              this.messageDialog = null;
            });
          }
          //if call succeeded invoke getWells to update table
          if (x.Success == true) {
            this.userWellsService.GetWells();
          }
        }
      }
    });

    //Subscribe to the result parameter on the injection service.
    this.submitBhpBatchSubscription = this.bhpService.submitBatchResult.subscribe((x) => {

      //Close loading dialog
      if (this.loadingDialog) {
        this.loadingDialog.close();
      }

      if (x != null) {

        //If error is return with reasons load the error dialog component
        if (x.Reasons && x.Reasons.length > 0) {
          this.dialog.open(ApiResultErrorDialogComponent, {
            data: x
          });
        } else {
          let title, message;
          if (x.Success == true) {
            title = 'Success';
            message = 'Your injection records have been submitted successfully.';
          }
          else {
            title = 'Error';
            message = 'Something went wrong with your submission, please review your template and try again.';
          }
          if (!this.messageDialog) {
            this.messageDialog = this.dialog.open(MessageDialogComponent, {
              data: {
                title: title,
                message: message
              }
            }).afterClosed().subscribe(() => {
              this.messageDialog = null;
            });
          }

          //if call succeeded invoke getWells to update table
          if (x.Success == true) {
            this.userWellsService.GetWells();
          }
        }
      }
    });

    this.dataSource = new MatTableDataSource<WellDetailsModel>(initData);

    this.dataSource.filterPredicate = (data: WellDetailsModel, filter: string) => {
      var ret: boolean = true;

      var filterObj: WellsListFilterModel = <WellsListFilterModel> JSON.parse(filter);

      function stringFilter(keyName) {
        try {
          var needle = filterObj[keyName].toLowerCase();

          if (needle != undefined && needle != null && needle != "") {
            var haystack = data[keyName];
            var ind = haystack.toLowerCase().indexOf(needle);

            if (ind == -1) {
              ret = false;
            }
            else {
              let q = 0;
            }
          }
        }
        catch (ex) {

        }
      }

      stringFilter("Apinumber");
      stringFilter("Uicnumber");
      stringFilter("LeaseName");
      stringFilter("WellNumber");
      stringFilter("OperatorOperatorName");

      //Filter on the exclude zero injections field.
      if (filterObj.ExcludeZeroInjections) {
        if (data.InjectionsCount == 0) {
          ret = false;
        }
      }

      //Filter based on whether or not the wuell is in the favorites list.
      if (filterObj.ShowFavorites) {
        if (!this.userPrefs.FavoriteWellIds.includes(data.Id)) {
          ret = false;
        }
      }

      return ret;
    };
  }

  ngOnInit() {
    this.userWellsService.onWellDataUpdate().subscribe(newWellData => {
      this.dataSource.data = newWellData;

      //Force the filters to apply so that the table gets filtered right.
      this.applyFilter();
    });

    this.userAcountService.getMyUserPrefs().then((userPrefs: any) => {
      this.userPrefs = userPrefs;

      //Force the filters to apply so that the table gets filtered right.
      this.applyFilter();
    });


    var sFilterEntity = localStorage.getItem('disposalHomeSearchParams');

    if (sFilterEntity == null) {
      this.filterEntity = new WellsListFilterModel();
    }
    else {
      var filterEntity = <WellsListFilterModel>JSON.parse(sFilterEntity);
      this.filterEntity = filterEntity;
    }
    
    this.filterType = MatTableFilter.ANYWHERE;

    this.userWellsService.GetWells();

  }

  applyFilter() {

    this.dataSource.filter = JSON.stringify(this.filterEntity);

    //Save the state of the filter form
    this.saveFilterFormState();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
  }

  ngOnDestroy(): void {
    this.handleNavigateAway();
  }

  @HostListener("window:beforeunload", ['$event'])
  beforeUnloadHandler(event) {
    this.handleNavigateAway();
  }


  handleNavigateAway() {

    //Unsubscribe from the event subscriptions
    if (this.excelTemplateDataSubscription != null) {
      this.excelTemplateDataSubscription.unsubscribe();
    }
    if (this.submitInjectionBatchSubscription != null) {
      this.submitInjectionBatchSubscription.unsubscribe();
    }
    if (this.submitBhpBatchSubscription != null) {
      this.submitBhpBatchSubscription.unsubscribe();
    }
   
    //When leaving home component save the user preferences
    this.userAcountService.saveMyUserPrefs(this.userPrefs);
  }

  handleAddWellClick() {
    alert("adding well");
  }

  filterFieldHandleClick(event: Event) {
    event.stopPropagation();
  }

  saveFilterFormState() {
    localStorage.setItem('disposalHomeSearchParams', JSON.stringify(this.filterEntity));
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: WellDetailsModel): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.PermitNumber}`;
  }

  export(option: ExportOption) {
    var today = new Date();
    var aYearAgo = new Date(today);
    aYearAgo.setFullYear(aYearAgo.getFullYear() - 1);

    var wellIds = new Array<number>();

    this.selection.selected.forEach((wdm) => {
      wellIds.push(wdm.Id);
    });

    //Theoretically, we'd need to 
    var req = new ExportRequest();
    req.BeginYear = null;
    req.BeginMonth = null;
    req.EndYear = null;
    req.EndMonth = null;
    req.WellIds = wellIds;
    req.Format = option.Key;

    this.dialog.open(ExportDateRangeSelectorComponent, {
    }).afterClosed().subscribe((result: any) => {

      req.BeginYear = result.BeginDate.getFullYear();
      req.BeginMonth = result.BeginDate.getMonth() + 1;
      req.EndYear = result.EndDate.getFullYear();
      req.EndMonth = result.EndDate.getMonth() + 1;

      this.exportManagerService.export(req, true).then((result) => {
        var q = 0;
      },
        (err) => {
          var q = 0;
        });
    });


  }

  clearFilters() {
    this.filterEntity.Apinumber = "";
    this.filterEntity.Uicnumber = "";
    this.filterEntity.LeaseName = "";
    this.filterEntity.WellNumber = "";
    this.filterEntity.OperatorOperatorName = "";
    this.filterEntity.ExcludeZeroInjections = false;
  }

  hasFilters() {
    let ret: boolean = false;

    if(
      (this.filterEntity.Apinumber != null && this.filterEntity.Apinumber != "") ||
      (this.filterEntity.Uicnumber != null && this.filterEntity.Uicnumber != "") ||
      (this.filterEntity.LeaseName != null && this.filterEntity.LeaseName != "") ||
      (this.filterEntity.WellNumber != null && this.filterEntity.WellNumber != "") ||
      (this.filterEntity.OperatorOperatorName != null && this.filterEntity.OperatorOperatorName != "") ||
      (this.filterEntity.ExcludeZeroInjections != null && this.filterEntity.ExcludeZeroInjections != false)
    ) {
      ret = true;
    }

    return ret;
  }

  getMultiWellTemplate(templateType: string) {
    let selectedWells = this.selection.selected;

    let selectedWellsValidation = true;
    let invalidWellList = [];
    selectedWells.forEach(well => {
      //If formations array is empty or null fail validation check
      if (well.Formations == null || well.Formations.length == 0) {
        selectedWellsValidation = false;
        invalidWellList.push(well.Uicnumber);
      }
    });

    //If all wells pass validation open SelectPeriodDialogComponent
    if (selectedWellsValidation) {

      let dialogComponent;

      switch (templateType) {
        case 'injection_volume':
          dialogComponent = SelectPeriodDialogComponent
          break;
        case 'BottomHolePressure':
          dialogComponent = BhpDialogComponent
          break;
      }

      this.dialog.open(dialogComponent, {
      }).afterClosed().subscribe( async (result: any) => {

        //Did dialog return content?
        if (result) {


          let dataColumnsList;

          switch (templateType) {
            case 'injection_volume':
              dataColumnsList = await this.injectionService.getCombinedDataColumnsList();
              break;
            case 'BottomHolePressure':
              dataColumnsList = await this.bhpService.getCombinedDataColumnsList(result.method);
              break;
          }



          //Populate with last injection data?
          if (result.useLastInjData) {

            let injectionDataPromiseList = [];

            if (templateType == 'injection_volume') {
              injectionDataPromiseList = selectedWells.map((well) => {
                return this.injectionService.GetLastInjectionRecordWithWellId(well.Id);
              });
            }

            if (templateType == 'BottomHolePressure') {
              injectionDataPromiseList = selectedWells.map((well) => {
                return this.bhpService.GetLastInjectionRecordWithWellId(well.Id);
              });
            }


            Promise.all(injectionDataPromiseList).then((injectionDataList: any) => {

              //If promise returns null replace with empty object
              injectionDataList = injectionDataList.map((injRecord) => {
                if (!injRecord) {
                  return {};
                }
                return injRecord;
              })

              if (templateType == 'injection_volume') {
                injectionDataList = injectionDataList.map((injRecord, index) => {
                  if (!injRecord.FormationIds) {
                    return injRecord;
                  }
                  injRecord.FormationIds = injRecord.FormationIds.map((formationId) => {
                    //Find correlated formation name from selectedWells
                    return selectedWells[index].Formations.reduce((acc, val) => {
                      if (val.Id == formationId) {
                        acc = val.Name;
                      }
                      return acc;
                    }, '');
                  }).join(',');
                  return injRecord;
                });
              }
              this.excelImportService.generateTemplateMultiWell(selectedWells, result.beginDate, result.endDate, 'daily', templateType, dataColumnsList, injectionDataList);
            });

          } else {
            this.excelImportService.generateTemplateMultiWell(selectedWells, result.beginDate, result.endDate, 'daily', templateType, dataColumnsList, []);
          }
        }
      });

    }
    else {

      this.dialog.open(MessageDialogComponent, {
        data: {
          title: "Missing Well Formations",
          message: `The following well(s) by UIC Number: ${invalidWellList.join(', ')} do not have a Formation selected. This a requirement before you can submit data. Please provide the correct Formation for each well and try again.` 
        }
      });

    }


  }

  async uploadMutliWellTemplate(controllerName: string) {
    this.controllerName = controllerName;
    let dataColumnsList;

    switch (controllerName) {
      case 'injection':
        dataColumnsList = await this.injectionService.getCombinedDataColumnsList();
        break;
      case 'injectionPressure':
        dataColumnsList = await this.bhpService.getCombinedDataColumnsList();
        break;
    }

    let importConfig: any = {};
    importConfig.data = {
      controllerName,
      dataColumnsList
    };
    this.dialog.open(ImportExcelDataComponent, importConfig);
  }

  toggleFav(wellId, enable) {
    let _this = this;
    function generateTimeout() {
      return setTimeout(function () {
        _this.saveUserPrefsTimeout = null;
        _this.userAcountService.saveMyUserPrefs(_this.userPrefs);
      }, 10000);
    }

    if (enable) {
      this.userPrefs.FavoriteWellIds.push(wellId);
    } else {
      let wellIdIndex = this.userPrefs.FavoriteWellIds.indexOf(wellId);
      this.userPrefs.FavoriteWellIds.splice(wellIdIndex, 1);
    }

    //If the timer is currently active reset it.
    if (this.saveUserPrefsTimeout) {
      clearTimeout(this.saveUserPrefsTimeout);
    }

    //Initialize timer
    this.saveUserPrefsTimeout = generateTimeout()
  }

  updateTableSort(sort: Sort) {

    function compare(a: number | string, b: number | string, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    function booleanCompare(a: boolean, b: boolean) {
        return Number(a) - Number(b);
    }

    //Make sure we have parameters to actually sort by...
    if (!sort.active || sort.direction === '') {
      return;
    }

    let sortedData = this.dataSource.data.sort((a, b) => {
      let ret = 0;

      let isAsc = sort.direction === "asc";

      //The favorite field is a special case.
      if(sort.active == "favorite") {
        let isFavoriteA = this.userPrefs.FavoriteWellIds.includes(a.Id);
        let isFavoriteB = this.userPrefs.FavoriteWellIds.includes(b.Id);

        let intm = booleanCompare(isFavoriteA, isFavoriteB);

        if(!isAsc && intm != 0) {
          intm = intm * -1;
        }

        ret = intm;
      }
      else {
        ret = compare(a[sort.active], b[sort.active], isAsc)
      }

      return ret;

    });

    this.dataSource.data = sortedData;

  }
}
